import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Clock } from "lucide-react";
import { userApi } from "../lib/api";
import { track } from "../lib/analytics";
import { useCart } from "../context/CartContext";
import Seo from "../components/Seo";

export default function PaymentResult() {
  const [sp] = useSearchParams();
  const oid = sp.get("oid");
  const { clear } = useCart();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    let tries = 0;
    const poll = () => {
      userApi.get(`/orders/${oid}`).then(({ data }) => {
        if (data.status === "paid") { setStatus("paid"); clear(); track("payment_success", { oid }); }
        else if (data.status === "failed") { setStatus("failed"); track("payment_failure", { oid }); }
        else if (tries++ < 8) setTimeout(poll, 2000);
        else setStatus("pending");
      }).catch(() => setStatus("failed"));
    };
    if (oid) poll();
  }, [oid]);

  const cfg = {
    checking: { icon: Clock, color: "text-brand-gold", title: "Ödeme kontrol ediliyor…", desc: "Lütfen bekleyin." },
    paid: { icon: CheckCircle2, color: "text-brand-green", title: "Ödemen başarılı!", desc: "Siparişin onaylandı. Teşekkürler." },
    failed: { icon: XCircle, color: "text-red-600", title: "Ödeme tamamlanamadı", desc: "Ödeme başarısız oldu veya iptal edildi." },
    pending: { icon: Clock, color: "text-brand-gold", title: "Ödemen işleniyor", desc: "Ödemen onaylandığında hesabından görebilirsin." },
  }[status];
  const Icon = cfg.icon;

  return (
    <section className="pt-40 pb-32 bg-brand-offwhite min-h-[70vh]">
      <Seo title="Ödeme Sonucu" />
      <div className="max-w-md mx-auto px-6 text-center bg-brand-cream border border-brand-gold-light/40 rounded-sm p-12">
        <Icon className={`mx-auto ${cfg.color}`} size={56} />
        <h1 className="font-serif text-3xl text-brand-green mt-5">{cfg.title}</h1>
        <p className="text-brand-text/70 mt-3">{cfg.desc}</p>
        {oid && <p className="text-brand-text/50 text-sm mt-2">Sipariş No: {oid}</p>}
        <div className="mt-8 flex gap-3 justify-center">
          <Link to="/hesabim/siparislerim" className="bg-brand-gold text-brand-offwhite px-6 py-3 rounded-sm font-semibold">Siparişlerim</Link>
          <Link to="/magaza" className="border border-brand-gold text-brand-green px-6 py-3 rounded-sm font-semibold">Mağaza</Link>
        </div>
      </div>
    </section>
  );
}
